import gql from 'graphql-tag';
import {
  OrganizationId,
  SummaryDataStub,
  SummaryData,
  ISummaryData,
  IInterval,
} from '@kaizenplatform/intelligence-entity';
import GraphQLClient from '../../adapter/GraphQLClient';
import sleep from '../../utility/sleep';

class SummariesWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public summariesStub = async (): Promise<SummaryData> => {
    await sleep(2000);
    return new SummaryDataStub();
  };

  public businessSummaries = async (organizationId: OrganizationId, period: IInterval[]): Promise<SummaryData[]> => {
    const result = await this.graphqlClient.query(
      gql`
        query summaries($organizationId: ID!, $period: [IntervalInput!]!) {
          summaries(organizationId: $organizationId, periods: $period) {
            label
            sales {
              label
              value
            }
            visitors {
              label
              value
            }
            purchasers {
              label
              value
            }
            salesByVisitors {
              label
              value
            }
          }
        }
      `,
      {
        organizationId,
        period,
      },
    );

    return result.summaries.map((summary: ISummaryData) => SummaryData.fromJSON(summary));
  };

  public usersSummaries = async (organizationId: OrganizationId, period: IInterval[]): Promise<SummaryData[]> => {
    const result = await this.graphqlClient.query(
      gql`
        query summaries($organizationId: ID!, $period: [IntervalInput!]!) {
          summaries(organizationId: $organizationId, periods: $period) {
            label
            sales {
              label
              value
            }
            visitors {
              label
              value
            }
            salesByVisitors {
              label
              value
            }
            visitorsBySession {
              label
              value
            }
            visitorsByPv {
              label
              value
            }
            purchaseRates {
              label
              value
            }
          }
        }
      `,
      {
        organizationId,
        period,
      },
    );

    return result.summaries.map((summary: ISummaryData) => SummaryData.fromJSON(summary));
  };
}

export default SummariesWebApi;
